import axios from 'axios';

const calculateBase = () => {
  switch (process.env.REACT_APP_ENV) {
    case 'production':
      return '//help.wh8.co';
    case 'staging':
      return '//stage.help.wh8.co';
    case 'development':
    default:
      return 'http://localhost:8080';
  }
};

export const base = calculateBase();

export const query = (query, variables) => {
  return axios(`${base}/graphql`, {
    data: {
      query,
      variables
    },
    method: 'POST'
  })
    .then(response => {
      if (response.data.errors) {
        return response.data;
      }

      return response.data.data;
    })
    .catch(e => {
      if (e.response == null) {
        console.log(e);
      } else {
        console.log(
          e.response.data.errors ? e.response.data.errors : e.response.data
        );
      }
      return null;
    });
};

export default query;



// WEBPACK FOOTER //
// ./src/utils/api.js